require('../../modules/es6.typed.array-buffer');
require('../../modules/es6.object.to-string');
module.exports = require('../../modules/_core').ArrayBuffer;
